import { ArrowUpRightIcon } from "@heroicons/react/24/outline";
import { useI18N } from "@sundae/react-hooks";
import { Button, FadeInBasic, Image, Text, toolkitCx } from "@sundae/ui-toolkit";
import cx from "classnames";
import { FC, useCallback } from "react";
import { readableAdaAssetId } from "../../../constants/cardano.constants";
import useAppNavigate from "../../../hooks/router/useAppNavigate";
import { useTasteTestContext } from "../../../pages/TasteTestDetail/context";
import { IAssetMetaData } from "../../../types/Asset.types";
import { getAssetName } from "../../../utils/assets.utils";
import { locationFactories } from "../../../utils/routes.utils";

interface ITasteTestMissedOutProps {
  isSticky?: boolean;
}

const TasteTestMissedOut: FC<ITasteTestMissedOutProps> = ({ isSticky }) => {
  const { t } = useI18N("taste-test");
  const navigate = useAppNavigate();
  const {
    state: { tasteTest },
  } = useTasteTestContext();

  const handleTradeButton = useCallback(
    () =>
      navigate(
        locationFactories.exchange.swap({
          given: readableAdaAssetId,
          taken: tasteTest?.asset?.assetId ?? "",
        })
      ),
    [navigate, tasteTest?.asset?.assetId]
  );

  if (tasteTest) {
    return (
      <FadeInBasic
        className={cx(
          "relative h-72 overflow-hidden rounded-lg",
          {
            "animation-delay-100 motion-safe:animate-shadow-pulse": isSticky,
          },
          toolkitCx.layout.background.default
        )}
      >
        <Image
          src="/static/images/shapes/glossy-shape.png"
          className="absolute -right-32 top-0 z-[-1] rotate-90 select-none opacity-10 dark:opacity-5"
          width={400}
          height={400}
        />
        <div
          className={cx(
            "flex h-full flex-col justify-center gap-4",
            toolkitCx.layout.spacing.both.lg
          )}
        >
          <Text tag="h2" weight="medium" size="lg">
            {t("detail.missedOut.title")}
          </Text>
          <Text size="sm" tag="p" variant="muted">
            {t("detail.missedOut.description", {
              token: getAssetName(tasteTest.asset as unknown as IAssetMetaData),
            })}
          </Text>

          <Button className="w-fit" variant="neutral" onClick={handleTradeButton} size="md">
            {t("detail.missedOut.cta", {
              token: getAssetName(tasteTest.asset as unknown as IAssetMetaData),
            })}
            <ArrowUpRightIcon className="h-4 w-4" />
          </Button>
        </div>
      </FadeInBasic>
    );
  }

  return null;
};

export default TasteTestMissedOut;
